import React from 'react';
import { Link } from 'react-router-dom';

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Changelog', href: '/changelog' },
      { label: 'Status', href: '/status' },
    ],
  },
  {
    title: 'Developers',
    links: [
      { label: 'Docs', href: '/docs' },
      { label: 'API Reference', href: '/docs/api' },
      { label: 'SDK', href: '/docs/sdk' },
      { label: 'Webhooks', href: '/docs/webhooks' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '/blog' },
      { label: 'Careers', href: '/careers' },
      { label: 'Press', href: '/press' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
      { label: 'TCPA Policy', href: '/tcpa' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-white/[0.06] py-16 px-6">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-white font-bold text-lg tracking-tight mb-3 block">
              CallPilot
            </Link>
            <p className="text-xs text-zinc-500 leading-relaxed max-w-[160px]">
              AI voice agents that handle outbound calls at scale.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <div className="text-xs font-mono text-zinc-500 uppercase tracking-widest mb-3">{col.title}</div>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-zinc-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/[0.06] pt-6 text-xs text-zinc-600 text-center">
          © 2025 CallPilot · Built for scale
        </div>
      </div>
    </footer>
  );
}
